import {customElement,LitElementBase,html,repeat} from "#Shared/Lit";
import {AppointmentFieldModel} from "./AppointmentField.Model";
import {faCalendarTimes} from "@fortawesome/free-solid-svg-icons/faCalendarTimes";

@customElement('rn-appointment-time-picker')
export class AppointmentTimePicker extends LitElementBase{
    public model:AppointmentFieldModel;
    protected render(): unknown {
        if(this.model.flatPickr==null)
            return null;

        return html`
            <div class="dateLabelAndSlotContainer">
                <label class="long_date">${this.model.GetFormattedCalendarDate()}</label>
                <div style="padding: 20px 10px" class="dateSlotContainer">
                    ${this.GetAvailableTimes()}
                </div>
            </div>
        `
    }


    private GetAvailableTimes() {
        let slots=this.model.GetSlotsByDate(this.model.CalendarDate);
        if(slots.length==0)
            return html`
                <div style="text-align: center;display: flex;flex-direction: column;justify-content: center;align-items: center;height: 100%">
                    <rn-fontawesome style="font-size: 124px;color:#999;" .icon="${faCalendarTimes}"></rn-fontawesome>
                    <div style="text-align: center;color:#999">
                        ${this.NoSlotMessage()}
                    </div>
                </div>
            `
        return html`
            <div style="display: flex;align-items: flex-start;justify-content: center;flex-wrap: wrap">
                ${repeat(slots,slot=>slot.From,slot=>html`
                    <div class="slotItem ${slot.Date==this.model.Date?'rnSelected':''}" @click="${()=>this.Toggle(slot.Date)}">
                        ${slot.Label}
                    </div>
                
                `)}
            </div>
        `



    }

    private NoSlotMessage() {
        return 'No slots available'
    }

    private Toggle(date: number) {
        if(this.model.Date==date)
            this.model.SetDate(null);
        else
            this.model.SetDate(date);

    }
}